import { render, staticRenderFns } from "./AppStatistics.vue?vue&type=template&id=8b2c8c32&scoped=true"
import script from "./AppStatistics.vue?vue&type=script&lang=ts"
export * from "./AppStatistics.vue?vue&type=script&lang=ts"
import style0 from "./AppStatistics.vue?vue&type=style&index=0&id=8b2c8c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c8c32",
  null
  
)

export default component.exports